import { IComponentPlayerMetadata } from '@/shared/components/types.ts';
import { getOS, OperatingSystem } from '@/shared/tools/get-os.ts';
import { AppScreens } from '@/shared/types';
import { defineStore } from 'pinia';
import {
  onMounted,
  ref,
  Ref,
  watch,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useKeyboardDetect } from '@/shared/composables/useKeyboardDetect.ts';
import { useZoom } from '@/shared/composables/useZoom.ts';
import { saveLastActiveAppScreens } from '@/core/config.ts';

export const useMainStore = defineStore('mainStore', () => {
  const componentPlayerMetadata = ref<Map<string, IComponentPlayerMetadata>>(new Map());

  // enable promo-video after 30 sec of user inactive
  const mode = ref<string>('');

  // function that, 1000 ms after the curtains are opened on LoaderAtStartApp,
  // starts the animation of the buttons appearing on the global panel
  const actionPanelAnimeCallback = ref<() => void>(() => {
    // do nothing
  });

  const router = useRouter();
  const route = useRoute();

  const activeScreen: Ref<AppScreens> = ref(localStorage.getItem('last-active-app-screen') as AppScreens || AppScreens.Home);

  const handleActionByURL = () => {
    if (saveLastActiveAppScreens.includes(route.name as AppScreens)) {
      localStorage.setItem('last-active-app-screen', route.name as string);
    }

    switch (route.name) {
      case AppScreens.VideoBible:
      case AppScreens.PrayerExperience:
      case AppScreens.InteractiveBible:
      case AppScreens.ReadingPlans:
      case AppScreens.ReadingPlanDetail:
      case AppScreens.ReadingPlanDay:
      case AppScreens.Login:
      case AppScreens.Profile:
      case AppScreens.Stories:
      case AppScreens.Story:
      case AppScreens.Courses:
      case AppScreens.Home:
      case AppScreens.TextBible: {
        activeScreen.value = route.name;

        return;
      }
      default: {
        activeScreen.value = AppScreens.None;
      }
    }
  };

  watch(() => router.currentRoute.value, () => {
    handleActionByURL();
  });

  onMounted(() => {
    handleActionByURL();
  });

  // width of slide window wripper on desktop
  const desktopSlideContainerWidth: Ref<number> = ref(0);
  // height of slide window wripper on desktop
  const desktopSlideContainerHeight: Ref<number> = ref(0);

  // width of browser window
  const windowWidth: Ref<number> = ref(0);

  const sideMenuVisible: Ref<boolean> = ref(false);

  const deviceOS: OperatingSystem = getOS();

  const { keyboardVisible } = useKeyboardDetect();

  // zoom value for desktop (min-width: 601px)
  const { zoom } = useZoom();

  return {
    componentPlayerMetadata,
    mode,
    actionPanelAnimeCallback,
    activeScreen,
    desktopSlideContainerWidth,
    desktopSlideContainerHeight,
    windowWidth,

    sideMenuVisible,

    deviceOS,

    keyboardVisible,

    zoom,
  };
});
